import globals from '../../utils/globals'
import { t } from '../../libs/translationsUtils/translations'

export function getCurrentPage () {
  const bodyClasses = document.getElementsByTagName('body')[0].classList

  if (bodyClasses.contains('parent-category')) {
    return 'parent category'
  } else if (bodyClasses.contains('category-page')) {
    return 'category'
  } else if (bodyClasses.contains('twig_page-topic')) {
    return 'topic'
  } else if (bodyClasses.contains('forum--search')) {
    return 'search'
  } else if (bodyClasses.contains('twig_default-member-profile')) {
    return 'profile'
  } else if (bodyClasses.contains('twig_site-badges')) {
    return 'badges'
  } else if (bodyClasses.contains('twig_default-setting-profile')) {
    return 'settings'
  } else if (bodyClasses.contains('twig_site-index')) {
    return 'homepage'
  } else if (bodyClasses.contains('twig_topic-new')) {
    return 'create'
  }
  return 'other'
}

function getGATokens () {
  return new Promise((resolve, reject) => {
    let trackersList = []

    if (!window.ga) {
      resolve([])
    } else {
      var timing = setTimeout(function () {
        reject(new Error('GA timeout'))
      }, 2000)

      window.ga(function () {
        const trackers = window.ga.getAll()
        trackersList = trackers.map(tracker => tracker.get('name'))
        clearTimeout(timing)
        resolve(trackersList)
      })
    }
  })
}

function relativeDate (dateTime) {
  const diff = new Date(new Date().getTime() - dateTime)

  let date
  if (diff.getUTCFullYear() - 1970) {
    date = t('Forum', '{n} year|{n} years', { n: (diff.getUTCFullYear() - 1970).toString() })
  } else if (diff.getUTCMonth()) {
    date = t('Forum', '{n} month|{n} months', { n: (diff.getUTCMonth()).toString() })
  } else if (diff.getUTCDate() - 1) {
    date = t('Forum', '{n} day|{n} days', { n: (diff.getUTCDate() - 1).toString() })
  } else if (diff.getUTCHours()) {
    date = t('Forum', '{n} hour|{n} hours', { n: (diff.getUTCHours()).toString() })
  } else if (diff.getUTCMinutes()) {
    date = t('Forum', '{n} minute|{n} minutes', { n: diff.getUTCMinutes().toString() })
  } else {
    return t('Forum', 'just')
  }
  return t('Forum', '{plural} ago', { plural: date })
}

function isModuleActive (module) {
  return (globals('activeModules') || []).indexOf(module) !== -1
}

export const common = {
  getGATokens: getGATokens,
  isModuleActive: isModuleActive,
  relativeDate: relativeDate
}
